import { useTranslation } from "react-i18next";

import { Alert, AlertDescription, AlertTitle } from "~/components/ui/alert";
import { ConfettiIcon } from "~/components/ui/icons/confetti";

import { useBilling } from "./use-billing";

type InvoiceFullyPaidBannerProps = {
  isSubjectVat: boolean;
};

export const InvoiceFullyPaidBanner: React.FC<InvoiceFullyPaidBannerProps> = ({
  isSubjectVat,
}) => {
  const { t } = useTranslation();
  const { data: billing } = useBilling();

  const remainingAmount = isSubjectVat
    ? (billing?.total_remaining_ttc ?? 0)
    : (billing?.total_remaining_ht ?? 0);

  if (!billing || remainingAmount > 0) {
    return null;
  }

  return (
    <Alert className="border-[#C6E7D5] bg-[#ECF7F1] [&>svg]:text-green-900">
      <ConfettiIcon />
      <AlertTitle>
        {t("invoice.invoice_information.your_operation_fully_paid")}
      </AlertTitle>
      <AlertDescription>
        {t("invoice.invoice_information.see_you_soon")}
      </AlertDescription>
    </Alert>
  );
};
